import { toast } from "react-toastify";
import { DocumentNode } from "graphql";
// import { AuthType } from "~/constants";
import { sentryWrappedException } from "~/utils/Utils";
import "../../../configureAmplify";
import getClient from "./get_client";

export default async function getQuery<ReturnType>(query: DocumentNode, variables: object) {
  const client = getClient();

  // APP CODE
  try {
    const data = await client.hydrated().then((client_) => {
      // Now run a query
      return client_
        .query<ReturnType>({
          query,
          // @ts-expect-error
          disableOffline: true,
          variables,
        })
        .then((queryData) => {
          return queryData;
        });
    });
    return data.data;
  } catch (error) {
    sentryWrappedException(error);
    toast.error("Failed to run query");
    throw error;
  }
}
